import { forwardRef, useMemo } from 'react';
import { TextInputBase } from './TextInputBase';
import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const TextInput = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    displayLabel = true,
    ...rest
  } = props;
  const effectiveClassName = useMemo(() => clsx(['ids-text-input', className]), [className]);
  return /*#__PURE__*/_jsx(TextInputBase, {
    className: effectiveClassName,
    displayLabel,
    ...rest,
    ref: ref
  });
});
TextInput.displayName = 'TextInput';